import { create } from "zustand";
import { toast } from "react-toastify";
import { MatchDetails, MatchSetupConfig } from "../models/match";
import { matchesService } from "../services/matchesService";

interface MatchesStoreInterface {
  allMatches: MatchSetupConfig[];
  currentSetup: MatchSetupConfig | null;
  selectedMatch: MatchDetails | null;

  inProgressMatch?: any;
  isBusy: boolean;
  error: string | null;
  loadAllMatchesForTeam: (seasonId: string, teamId: string) => void;
  setSelectedMatch: (match: MatchDetails | null) => void;
  clearError: () => void;
  saveSelectedPlayersForMatch: (matchId: string, selectedPlayersInTeam: any) => void;
  getInProgressMatchSetup: (seasonId: string) => void;
}

export const useMatchesStore = create<MatchesStoreInterface>((set, get) => ({
  allMatches: [],
  currentSetup: null,
  selectedMatch: null,
  isBusy: false,
  error: null,

  setSelectedMatch: async (match) => {
    set({ selectedMatch: match });
    if (match && get().allMatches.length > 0) {
      const setup = get().allMatches.find((m) => m.matchId === match.id);
      if (setup) {
        set({ currentSetup: setup });
      } else {
        set({ currentSetup: null });
      }
    } else {
      set({ currentSetup: null });
    }
  },

  loadAllMatchesForTeam: async (seasonId, teamId) => {
    try {
      set({ isBusy: true, error: null });
      const response = await matchesService.getAllMatchesForTeam(
        seasonId,
        teamId
      );
      set({ allMatches: response.result });
    } catch (err: any) {
      const errorMessage = err.message || "Failed to load matches";
      set({ error: errorMessage });
      toast.error(errorMessage);
    } finally {
      set({ isBusy: false });
    }
  },

  clearError: () => set({ error: null }),

  saveSelectedPlayersForMatch: async (matchId: string, selectedPlayersInTeam: any) => {
    try {
      set({ isBusy: true, error: null });
      const res =await matchesService.updateMatchWithSelectedPlayers(matchId, selectedPlayersInTeam);
      if (res && res.statusCode === 200) {
        toast.success("Players saved successfully");
      } else {
        const errorMessage = res.message || "Failed to save players";
        toast.error(errorMessage);
      }
    } catch (err: any) {
      const errorMessage = err.message || "Failed to save players";
      set({ error: errorMessage });
      toast.error(errorMessage);
    } finally {
      set({ isBusy: false });
    }
  },
  getInProgressMatchSetup: async (seasonId: string) => {
    try {
      set({ isBusy: true, error: null });
      const response = await matchesService.getInProgressMatchSetup(seasonId);
      if (response.statusCode === 200) {
      set({ inProgressMatch: response.result }); 
      } else {
        const errorMessage = response.message || "Failed to load in-progress match";
        set({ error: errorMessage, inProgressMatch: null });
        toast.error(errorMessage);
      }
    } catch (err: any) {
      const errorMessage = err.message || "Failed to load in-progress match";
      set({ error: errorMessage });
      toast.error(errorMessage);
    } finally {
      set({ isBusy: false });
    }
  }

}));
